import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import EyeIcon from '@mui/icons-material/RemoveRedEye';
import { TableTooltip } from '../table';
import { DateTooltipProps } from './props';

dayjs.extend(relativeTime);
dayjs.locale('es');

export const DateTooltip = ({
    date,
    icon,
    format = 'D [de] MMMM [a las] HH:mm',
    tooltip,
    showFornow,
    showDate2,
    substractHours = 5,
}: DateTooltipProps) => {
    let customDate: any = dayjs(date);
    let customDate2: any = dayjs(date);

    if (substractHours) {
        customDate = customDate.subtract(substractHours, 'hours');
        customDate2 = customDate2.subtract(substractHours, 'hours');
    }

    if (showFornow) customDate = customDate.fromNow();
    if (showDate2 && showFornow) customDate2 = customDate2.format(format);
    else if (customDate && typeof customDate === 'object')
        customDate = customDate.format(format);

    return (
        <TableTooltip value={tooltip || customDate}>
            {icon || (
                <EyeIcon sx={{ marginRight: '10px', color: 'primary.main' }} />
            )}
            {showDate2 && showFornow ? `${customDate2} ` : customDate}
        </TableTooltip>
    );
};
